import { render } from "./Smartfolders.vue?vue&type=template&id=340e3200&scoped=true"
import script from "./Smartfolders.vue?vue&type=script&lang=js"
export * from "./Smartfolders.vue?vue&type=script&lang=js"

import "./Smartfolders.vue?vue&type=style&index=0&id=340e3200&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340e3200"]])

export default __exports__